import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Fotter from "../components/Fotter";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Price.css"; // Import your CSS file
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "./Config";

export default function Price() {
  const [userdata, setUserdata] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const { plan } = location.state || {};


  const [userdataplane, setUserdataplane] = useState(plan.title);
  const [userpalne, setUserpalne] = useState();

  const userId = Cookies.get("user_id");

  const fetchUserData = () => {
    axios
      .get(`${BASE_URL}/get_user_by_id.php?id=${userId}&t=${Date.now()}`)
      .then((res) => {
        if (res.data.success) {
          const userData = res.data.data[0];
          setUserdata(res.data.data);
          setUserpalne(res.data.data.membership_type);
          // setUser(userData);
          //  console.log("userdata", res.data.data);
          // setName(res.data.data.name);
          // setImage(`${BASE_URL}/uploads/${res.data.data.image}`);
        } else {
          console.error("API response error:", res.data.message);
        }
      })
      .catch((err) => console.error("API request failed:", err));
  };

  useEffect(() => {
    if (!userId) return; // prevent running if userId not ready

    // Call immediately once
    fetchUserData();
  }, [userId]);

  // console.log("user data :", plan);



  // console.log("user 1 plane :", userdataplane);
  // console.log("user 2 plane :", userpalne);

  useEffect(() => {
    if (userdataplane == userpalne) {
      navigate("/membership");
    }
  }, [userdataplane, userpalne, navigate]);



  const today = new Date();
  const nextMonth = new Date();
  nextMonth.setMonth(nextMonth.getMonth() + 1);

  // Format: DD/MM/YYYY
  const format = (d) =>
    `${String(d.getDate()).padStart(2, "0")}/${String(
      d.getMonth() + 1
    ).padStart(2, "0")}/${d.getFullYear()}`;

  const todayDate = format(today);
  const nextMonthDate = format(nextMonth);

  const [loading, setLoading] = useState(false);

  const handleProceed = () => {
    if (!userdata || !plan) {
      alert("Something went wrong! Please try again.");
      return;
    }

    setLoading(true); // 🔥 loader start

    const payload = {
      user_id: userId,
      name: userdata.name,
      email: userdata.email,
      phone: userdata.phone_num,
      address: userdata.address,
      plan_id: plan.id,
      plan_title: plan.title,
      amount: plan.amount,
      start_date: todayDate,
      end_date: nextMonthDate,
      payment_type: "membership"
    };

    axios
      .post(`${BASE_URL}/Payment_process.php`, payload)
      .then((res) => {
        if (res.data.success && res.data.redirection_url) {
          // ✅ loader chalta rahega jab tak redirect na ho
          window.location.href = res.data.redirection_url;
        } else {
          setLoading(false); // ❗ only on error
          alert("Error: " + (res.data.message || "Payment failed"));
        }
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false); // ❗ network error pe loader band
        alert("Network error occurred!");
      });
  };


  return (
    <>
      <Navbar />

      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME</p>
                </Link>
                <span> /</span>
                <p>Price</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-settings">
        <div className="container price-container">
          {/* Payment Section */}
          <div className="payment-box">
            <h2>User Information</h2>

            <label>User Name</label>
            <input
              type="text"
              placeholder="Ex. Jane Cooper"
              value={userdata.name}
            />

            <label>Email</label>
            <input
              type="email"
              placeholder="Ex. Jane Cooper"
              value={userdata.email}
            />

            <label>Phone Number</label>
            <input
              type="number"
              placeholder="+996 567 890 12"
              value={userdata.phone_num}
            />

            <label>Address</label>
            <input type="text" placeholder="" value={userdata.address} />
          </div>

          {/* Plan Section */}
          <div className="plan-box">
            <div className="plan-card">
              <h3
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  borderBottom: "2px solid white",
                  paddingBottom: "15px",
                }}
              >
                Your Plan <span>{plan.title}</span>
              </h3>

              <div dangerouslySetInnerHTML={{ __html: plan.benifits }} />
            </div>

            <div className="plan-summary">
              <p
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                Subtotal <span> {plan.amount} SAR</span>
              </p>
              <p
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                Start by <span>{todayDate}</span>
              </p>

              <p
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                End by <span>{nextMonthDate}</span>
              </p>

              <p
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  borderTop: "2px solid black",
                }}
              >
                <strong
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                    fontWeight: "800",
                  }}
                >
                  <span>Total</span>
                  <span>{plan.amount} SAR</span>
                </strong>
              </p>

              <button
                className="pay-btn"
                onClick={handleProceed}
                disabled={loading}
              >
                {loading ? "Processing..." : "Proceed"}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Loading Overlay */}
      {loading && (
        <div
          className="loading-overlay"
          style={{
            position: "fixed",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            width: "100%",
            top: "0",
            zIndex: "999999",
            background: "##0000003d",
          }}
        >
          <div className="dot-spinner">
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
            <div className="dot-spinner__dot"></div>
          </div>
        </div>
      )}

      <Fotter />
    </>
  );
}
